import type { PaletteColor } from "../types/color-palette";

export const getFormattedPalette = (colorName: PaletteColor) =>
  colorName?.toLocaleLowerCase().replace(/\s/g, "-");
